/**
 * editDocument.js — Simplified scan component WITHOUT frontend queue.
 *
 * FIX: Uses /scan-status/ API endpoint for completion check
 * instead of stale props.documents from Redux.
 */

import * as React from "react";
import Box from "@mui/material/Box";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import TextField from "@mui/material/TextField";
import {useEffect, useState, useRef} from "react";
import {connect} from "react-redux";
import scan_img from '../scan.png'
import audio_err from '../warn.mp3'
import audio_finish from '../finish.mp3'
import {getAlLThis, messageReset} from "../store/documents";
import axios from 'axios';
import {getAllVerifyResponse} from "../store/logIn";
import Dialog from '@mui/material/Dialog';
import {Slide, toast} from "react-toastify";

const API_BASE = 'https://fx.softmakon.uz/api';

function EditDocument(props) {
    let audio = new Audio(audio_err)
    let finish = new Audio(audio_finish)
    const params = useParams()
    const [searchParams] = useSearchParams()
    const [code, setCode] = useState('')
    const [open, setOpen] = useState(false)

    // Track type from URL
    const trackType = React.useMemo(() => {
        let type = searchParams.get('type')
        if (!type) {
            if (searchParams.has('avia')) type = 'avia'
            else if (searchParams.has('fura')) type = 'fura'
            else if (searchParams.has('avia_tracking')) type = 'avia_tracking'
        }
        return type || props.openItem?.type
    }, [searchParams, props.openItem])

    const textFieldRef = useRef(null);
    const scanCount = useRef(0);
    const lastScanTime = useRef(0);
    const lastScannedCode = useRef('');
    const inFlightRequests = useRef(0);
    const completionCheckTimeout = useRef(null);

    const handleClose = () => {
        setOpen(false);
        scanCount.current = 0;
        inFlightRequests.current = 0;

        if (completionCheckTimeout.current) {
            clearTimeout(completionCheckTimeout.current);
            completionCheckTimeout.current = null;
        }

        // Refresh parent data before closing
        const data = {
            "part": params['part'],
            "code": params['code'],
            "type": trackType
        };
        props.getAlLThis(data);

        setTimeout(() => {
            props.setOpen(false);
            props.setOpenItem(false);
        }, 100);
    };

    useEffect(() => {
        if (props.open) {
            setOpen(props.open);
            scanCount.current = 0;
            inFlightRequests.current = 0;

            setTimeout(() => {
                if (textFieldRef.current) {
                    textFieldRef.current.focus();
                }
            }, 50);
        }
    }, [props.open, trackType]);

    /**
     * Get the correct scan endpoint URL based on track type.
     */
    const getScanUrl = () => {
        if (trackType === 'avia')          return `${API_BASE}/combined-tracking/scan/`;  // AviaTrackCode (eski model)
        if (trackType === 'fura')          return `${API_BASE}/fura-scan/scan/`;
        if (trackType === 'avia_tracking') return `${API_BASE}/avia-scan/scan/`;           // AviaTracking (yangi model)
        return null;
    };

    /**
     * Get the correct scan-status endpoint URL based on track type.
     */
    const getScanStatusUrl = () => {
        if (trackType === 'avia')          return null;  // combined-tracking status yo'q — eski xatti-harakat
        if (trackType === 'fura')          return `${API_BASE}/fura-scan/scan-status/`;
        if (trackType === 'avia_tracking') return `${API_BASE}/avia-scan/scan-status/`;
        return null;
    };

    /**
     * Check completion using the /scan-status/ API endpoint.
     * This gets FRESH data from the database — not stale Redux state.
     */
    const checkForCompletion = async () => {
        if (completionCheckTimeout.current) {
            clearTimeout(completionCheckTimeout.current);
        }

        // Wait a moment for DB to settle
        completionCheckTimeout.current = setTimeout(async () => {
            try {
                const statusUrl = getScanStatusUrl();
                if (!statusUrl || !props.openItem) return;

                const response = await axios.get(statusUrl, {
                    params: {
                        serial_number: props.openItem['part'],
                        code: props.openItem['code']
                    }
                });

                const {remaining, complete, scanned, total} = response.data;

                console.log(`Scan status: ${scanned}/${total} scanned, ${remaining} remaining`);

                if (complete && scanCount.current > 0 && inFlightRequests.current === 0) {
                    // ALL track codes are scanned!
                    finish.play();
                    toast.success("Barchasi muvaffaqiyatli saqlandi!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        theme: "colored",
                        transition: Slide,
                    });
                    props.messageReset();

                    setTimeout(() => handleClose(), 300);
                }
            } catch (error) {
                console.error('Error checking scan status:', error);
            }
        }, 500);
    };

    /**
     * CORE SCAN FUNCTION — fires immediately, no queue.
     */
    const scanTrackCode = async (trackCode) => {
        const scanUrl = getScanUrl();
        if (!scanUrl || !props.openItem) return;

        inFlightRequests.current += 1;

        try {
            const response = await axios.patch(scanUrl, {
                serial_number: props.openItem['part'],
                code: props.openItem['code'],
                track_code: trackCode,
            });

            if (response.status === 200) {
                if (response.data.already_scanned) {
                    console.log('Already scanned:', trackCode);
                } else {
                    // Successfully scanned
                    toast.success("Muvaffaqiyatli saqlandi!", {
                        position: "top-right",
                        autoClose: 1200,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        theme: "colored",
                        transition: Slide,
                    });

                    scanCount.current += 1;
                }
            }
        } catch (error) {
            const errorStatus = error.response?.status;

            if (errorStatus === 404) {
                // Noto'g'ri trek kod — xatolik + modal yopiladi
                audio.play();
                toast.error("Trek kod topilmadi!", {
                    position: "top-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: "colored",
                    transition: Slide,
                });
                setTimeout(() => handleClose(), 400);
            } else {
                // Server xatolik — modal YOPILMAYDI, scan davom etadi
                console.error('Scan error:', error);
                toast.error("Xatolik yuz berdi!", {
                    position: "top-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: "colored",
                    transition: Slide,
                });
            }

            // Xatolikdan keyin modalni yopish
            setTimeout(() => handleClose(), 300);
        } finally {
            inFlightRequests.current -= 1;

            // Check completion after EVERY scan (using fresh API data)
            if (inFlightRequests.current === 0 && scanCount.current > 0) {
                checkForCompletion();
            }
        }
    };

    /**
     * SCANNER INPUT HANDLER
     */
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (code && props.openItem) {
                const now = Date.now();
                const trimmedCode = code.trim();

                // Bir xil kodni 2 sekund ichida qayta yubormaslik
                if (trimmedCode === lastScannedCode.current && now - lastScanTime.current < 2000) {
                    console.log('Duplicate scan ignored:', trimmedCode);
                    setCode('');
                    return;
                }

                lastScanTime.current = now;
                lastScannedCode.current = trimmedCode;

                // Fire immediately
                scanTrackCode(trimmedCode);
                setCode('');
            }
        }, 100);

        return () => clearTimeout(delayDebounceFn);
    }, [code, props.openItem]);

    // Handle legacy redux message flow
    useEffect(() => {
        if (props.message === 'error') {
            audio.play();
            toast.error("Xatolik! Trek kod to'g'ri kelmadi!", {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: "colored",
                transition: Slide,
            });
            props.messageReset();
            setTimeout(() => handleClose(), 400);
        }
    }, [props.message]);

    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'instant'});
        return () => {
            if (completionCheckTimeout.current) {
                clearTimeout(completionCheckTimeout.current);
            }
        };
    }, []);

    return <div>
        <Dialog
            open={open}
            onClose={handleClose}
            BackdropProps={{onClick: handleClose}}
            sx={{
                '& .MuiDialog-container': {
                    alignItems: 'flex-start'
                }
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Box
                component="main"
                sx={{flexGrow: 1, overflow: 'auto'}}>
                <div style={{padding: '20px 20px 30px 20px', overflow: "hidden"}}>
                    <h3 className={'page-title text-center'}>{"Iltimos Scan Qiling!"}</h3>
                    <div className={'scan-block'}>
                        <div className={"fingerprint scanning"}>
                            <img src={scan_img} alt="Scan"/>
                        </div>
                    </div>
                    <TextField
                        ref={textFieldRef}
                        onChange={(e) => setCode(e.target.value)}
                        value={code}
                        required
                        className={"inp-text"}
                        onBlur={e => e.target.focus()}
                        type={"text"}
                        autoFocus={true}
                        variant="outlined"
                        placeholder={"Trek kodni kiriting"}
                    />
                </div>
            </Box>
        </Dialog>
    </div>
}

export default connect(props => props.documents, {
    getAllVerifyResponse,
    getAlLThis,
    messageReset
})(EditDocument)